export default (year) => {
  var m = new Date(year, 0, 1)
  var dt = new Intl.DateTimeFormat('ja-JP-u-ca-japanese')
  var [{ value: era }, { value: year }] = dt.formatToParts(m)
  var str = era + year
  return str
}